import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AllSpecialitiesData } from 'src/app/_models/allSpecialities.model';
import { PushNotificationService } from 'src/app/_services/push-notification.service';
import { PushNotification } from 'src/app/_models/push-notification.model';
import { showNotification } from 'src/app/helpers/show-toast';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-push-notification-modal',
  templateUrl: './push-notification-modal.component.html',
  styleUrls: ['./push-notification-modal.component.scss'],
})
export class PushNotificationModalComponent implements OnInit {
  speciality: AllSpecialitiesData;
  pushNotificationForm: FormGroup;
  isSubmited: boolean = false;
  notification: PushNotification;

  public event: EventEmitter<any> = new EventEmitter();

  constructor(
    public bsModalRef: BsModalRef,
    private _formBuilder: FormBuilder,
    private pushNotificationService: PushNotificationService,
    public toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.pushNotificationForm = this._formBuilder.group({
      notificationTitle: ['', [Validators.required]],
      notificationMessage: ['', [Validators.required]],
    });
  }

  onPushNotificationSubmit() {
    this.notification = {
      notification: {
        title: this.pushNotificationForm.value.notificationTitle,
        body: this.pushNotificationForm.value.notificationMessage,
        sound: 'default',
        routeName: '',
        routeId: 0,
        appId: 2,
      },
      filteredModel: {
        appId: 2,
        gender: 0,
        CitiesList: [],
        specialitiesList: [this.speciality.id],
        fromBirthdayDate: null,
        toBirthdayDate: null,
      },
    };

    this.pushNotificationService
      .sendPushNotification(this.notification)
      .subscribe((res) => {
        this.isSubmited = false;
        this.pushNotificationForm.reset();
        showNotification('success', `Notification has been sent`, this.toastr);
      });

    this.bsModalRef.hide();
  }
}
